import { gsap, Power1, Power2, Power3, Power4 } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { Observer } from 'gsap/Observer'; // Use direct path
import { SplitText } from 'gsap/SplitText';
import { Flip } from 'gsap/Flip';

// Register plugins here so they are active as soon as this file is imported
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, Observer, SplitText, Flip);

// Export named members explicitly
export { gsap, Power1, Power2, Power3, Power4, ScrollTrigger, ScrollToPlugin, Observer, SplitText, Flip };
